import { ieFix } from "./utils/ie-fix";
import { iosVhFix } from "./utils/ios-vh-fix";
import SmoothScroll from "./vendor/smooth-scroll";

import { initModals } from "./modules/init-modals";
import { initForm } from "./modules/init-form";
import { initToggler } from "./modules/init-toggler";

// Utils
// ---------------------------------

ieFix();
iosVhFix();

// Modules
// ---------------------------------

initModals();
initToggler();
initForm();

// flatpickr(".form__input--date", {
//   locale: Russian,
// });

let scroll = new SmoothScroll('a[href*="#"]');
